import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../../shared/vars";

import {userLogout } from "../../../../store/actions/user";

import ProductItemVariant from './ProductItemVariant';

class ProductItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            variants: [],
            showVariants: false,
            isLoading: false,
            noVariants: false,
        }

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
		document.addEventListener("mousedown", this.handleVariantClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleVariantClickOutside);
	}

	setWrapperRef = (node) => {
		this.wrapperRef = node;
	}

	handleVariantClickOutside = (event) => {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({
                showVariants: false
            });
		}
    }
    
    handleClick(){
        // this.props.handleProductClick(this.props.prod);
        if(this.props.ignoreVariants){
            this.props.variantClicked(this.props.product, "featured_product", true);
        } else {
            this.checkIfProductHasVariants();
        }
    }

    variantClicked = (product, type, noVariants) => {
        this.props.variantClicked(product, type, noVariants);
    }

    checkIfProductHasVariants(){
        const { user } = this.props;
		this.setState(
			{ isLoading: true},
			() => {
				const token = user.token;
				const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
				return axios
					.get(REACT_APP_API_URL + "products-query/" + this.props.product.id, { headers: AUTH_HEADER })
					.then(response => {
						if (response.status === 403 || (response.data.status && response.data.status === 403)) {
							this.props.userLogout("admin");
						} else if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
							this.setState({ isLoading: false, error: response.data.message });
						} else {
							this.setState({
                                showVariants: true,
								isLoading: false,
                                variants: response.data.variants,
                                noVariants: response.data.variants === undefined || response.data.variants === null
							});
						}
					})
					.catch(err => {
						if (err.response) {
							this.setState({ isLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
						} else {
							this.setState({ isLoading: false, error: err.message });
						}
					});
			}
        );

    }

	render() {
        const { isSelected, currentlySelected } = this.props;
        const prod = this.props.product;

		const isActive = currentlySelected.some(item => {
            if(item.type === "product")
                return item.id === prod.id;
            else
                return item.product_id === prod.id;
        });

		return (
			<div className={"selection" + (isSelected ? " selected" : "") + (isActive ? " active" : "")} onClick={() => this.handleClick()}>
				<div className="txt">{prod.title}</div>
				<span className="icon-star-full" />
                {this.state.showVariants && 
                    <div className="ajax-search-content categories" ref={this.setWrapperRef}>
                        <div className="search-dialog-variant">
                            <div className="tooltip-arrow" />
                            <div className="content">
                                <ProductItemVariant currentlySelected={currentlySelected} noVariants={this.state.noVariants} isAll={true} product={prod} isSelected={true} variantClicked={this.variantClicked}/>
                                {!!this.state.variants && this.state.variants.map((variant, i) => {
                                    return <ProductItemVariant key={i} currentlySelected={currentlySelected} noVariants={this.state.noVariants} variant={variant} isAll={false} isSelected={false} variantClicked={this.variantClicked} />;
                                })}
                                {!this.state.variants &&
                                <div className="pt1">There are no variants for this product.</div>
                                }
                            </div>
                        </div>
                    </div>
                }
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user.admin
	};
};

export default connect(mapStateToProps,{userLogout})(ProductItem);



// WEBPACK FOOTER //
// ./src/components/admin/products/product-search/ProductItem.js